import styled, { keyframes } from 'styled-components';

// The rotating, growing-and-shrinking arc that used to be the `loading-animation.json` Lottie.
// Plain SVG + CSS: the Lottie player was ~300 KB of the members entry bundle just for this.
// Geometry matches the animation (200-unit canvas, r≈65.5, 12-unit round-capped stroke).

const RADIUS = 65.5;
const CIRCUMFERENCE = Math.ceil(2 * Math.PI * RADIUS);

const rotate = keyframes`
    to {
        transform: rotate(360deg);
    }
`;

const dash = keyframes`
    0% {
        stroke-dasharray: 1, ${CIRCUMFERENCE};
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: ${CIRCUMFERENCE * 0.75}, ${CIRCUMFERENCE};
        stroke-dashoffset: ${-CIRCUMFERENCE * 0.15};
    }
    100% {
        stroke-dasharray: ${CIRCUMFERENCE * 0.75}, ${CIRCUMFERENCE};
        stroke-dashoffset: ${-CIRCUMFERENCE + 2};
    }
`;

const Svg = styled.svg`
    display: block;
    width: 100%;
    height: 100%;
    animation: ${rotate} 2s linear infinite;

    circle {
        fill: none;
        stroke-linecap: round;
        animation: ${dash} 1.5s ease-in-out infinite;
    }

    @media (prefers-reduced-motion: reduce) {
        animation-duration: 6s;

        circle {
            animation: none;
            stroke-dasharray: ${CIRCUMFERENCE * 0.75}, ${CIRCUMFERENCE};
        }
    }
`;

export type LoadingArcProps = {
    // Any CSS colour; defaults to the surrounding text colour.
    color?: string;
    // In the 200-unit canvas.
    strokeWidth?: number;
    className?: string;
};

export const LoadingArc = ({ color = 'currentColor', strokeWidth = 12, className }: LoadingArcProps) => (
    <Svg viewBox="0 0 200 200" className={className} role="presentation" aria-hidden="true">
        <circle cx="100" cy="100" r={RADIUS} stroke={color} strokeWidth={strokeWidth} />
    </Svg>
);
